<template>
  <div>
    <div class="steps-layout-container" v-if="!isMobile">
      <header class="app-header" v-if="title">{{ title }}</header>
      <div class="steps-container">
        <div class="steps-siderbar">
          <h3 class="steps-siderbar-title">
            {{ $t("LayoutComponent.action.steps") }}
          </h3>
          <m-steps :current="value">
            <m-step v-for="step in steps" :title="step" :key="step"> </m-step>
          </m-steps>
        </div>
        <div class="steps-form">
          <slot></slot>
        </div>
      </div>
    </div>
    <div v-else>
      <MobileSteps :current="value" :items="steps"></MobileSteps>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { is_mobile } from 'govmo-common/src/utils/utils';
import MobileSteps from "../../MobileSteps.vue";
export default {
  model: {
    prop: "value",
    event: "change",
  },
  components: { MobileSteps },
  props: {
    title: String,
    value: Number,
    steps: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      isMobile: is_mobile()
    }
  }
};
</script>
<style lang="scss" scoped>
.steps-layout-container {
  .app-header {
    height: 64px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    font-size: 20px;
    font-weight: 700;
    padding-left: 24px;
  }

  .steps-container {
    display: flex;

    .steps-siderbar {
      width: 240px;
      margin-top: 20px;
      border-right: 1px solid rgba(0, 0, 0, 0.15);

      .steps-siderbar-title {
        margin-left: 24px;
        margin-right: 24px;
      }
    }

    .steps-form {
      flex: 1 1 auto;
    }
  }
}
</style>
